import { useState, useEffect } from 'react';

export default function CustomWindowSize() {
  const [getwindowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  function onWindowReSize() {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  }

  useEffect(() => {
    window.addEventListener('resize', onWindowReSize);

    return () => {
      window.removeEventListener('resize', onWindowReSize);
    };
  }, []);

  return getwindowSize;
}
